import { CCardImage } from '@coreui/react'
import CircularProgress from '@mui/material/CircularProgress'
import { useQuery } from '@tanstack/react-query'
import { Buffer } from 'buffer'
import { fileTypeFromBuffer } from 'file-type'
import isEmpty from 'lodash/isEmpty'
import PropTypes from 'prop-types'
import { useCallback, useEffect, useState } from 'react'
import { apiUrl, getHttpInit } from 'src/utils/api'
import { MS_TIME } from 'src/utils/timeUtils'
import ProductListIcon from '../../assets/dashboard_icons/dashboard-img@3x.png'
import styles from './marketingimage.module.scss'

const MarketingImage = ({ accountNumber }) => {
  const [marketingImg, setMarketingImg] = useState({
    src: null,
    extension: null,
    link: null,
  })

  const marketingImgReq = useQuery({
    enabled: !isEmpty(accountNumber) && (accountNumber || '').split('-').length > 1,
    retry: false,
    staleTime: MS_TIME.FIVE_MIN,
    queryKey: ['marketingImg', { region: (accountNumber || '').split('-')[0] }],
    queryFn: async ({ queryKey: [, params] }) => {
      const region =
        params && typeof params === 'object' && 'region' in params ? params.region : undefined

      const response = await fetch(apiUrl('marketing/image', { region }), getHttpInit('GET'))

      return response.ok ? response.json() : undefined
    },
    select: (data) => {
      if (data?.Response === 'Success') return data.Content.Result
    },
  })

  const updateMarketingImg = useCallback(async () => {
    if (marketingImgReq.data) {
      const { content, link } = marketingImgReq.data
      const contentBuffer = Buffer.from(content, 'base64')
      const type = await fileTypeFromBuffer(contentBuffer)
      setMarketingImg({
        src: `data:${type.mime};base64,${content}`,
        extension: type.ext,
        link,
      })
    } else setMarketingImg({ src: ProductListIcon, extension: null, link: null })
  }, [marketingImgReq.data])

  useEffect(() => {
    updateMarketingImg()
  }, [updateMarketingImg])

  if (marketingImgReq.isLoading) {
    return (
      <div className={styles.containerProductImageLoaderDiv}>
        <CircularProgress color="success" />
      </div>
    )
  }

  if (!marketingImg.src) return null

  return (
    <div className={styles.containerProductImageDiv}>
      <a href={marketingImg.link} target="_blank" rel="noreferrer">
        <CCardImage
          orientation="top"
          src={marketingImg.src}
          className={styles.productListImgStyling}
        />
      </a>
    </div>
  )
}

MarketingImage.propTypes = {
  accountNumber: PropTypes.string,
}

export default MarketingImage
